
import { getParentPath, PageConfig } from "./PathConfig";


export const getPreviousTab = (module, status, parentPath) => {
    try {
        const finalParentPath = parentPath ? parentPath : getParentPath();
        if (!tabConfigure[module]) {
            return null
        }
        if (!tabConfigure[module][status]) {
            return null
        }
        return `${finalParentPath}/${tabConfigure[module][status]}`;
    } catch (error) {
        console.error(error.message);
        return null;
    }
};


export const tabConfigure = {
    scoped: {
        SCOPED_INPRG: 'inprogress',
        SCOPED_NEW: 'new',
        SCOPED_CMPLT: 'completed'
    },
    inab: {
        INAB_NEW: 'new',
        wavicle_projects: 'projectsinflight',
        INAB_APPROVED: 'approved',
        INAB_COMPLETED: 'completed',
        INAB_REJECTED: 'cancelledrejected',
    },
    dealreview: {
        DR_NEW: 'new',
        DR_INPRG: 'inprogress',
        DR_INREV: 'inreview',
        DR_REOPEN: 'reopen',
        DR_APVD: 'approved',
        DR_PEND: 'legalpending',
        DR_CMPLT: 'completed',
        DR_DEAL_LOST: 'completed',
    },
    legalreview: {
        LEG_NEW: 'new',
        LEG_INPRCS: 'inprocess',
        LEG_VLDT: 'validation',
        LEG_REV: 'inreview',
        LEG_CUST_REV: 'inreview',
        LEG_SIG_PEND: 'signpend',
        LEG_CUST_APVD: 'inreview',
        LEG_CUST_REJ: 'inprogress',
        LEG_CMPLT: 'completed',
    },
    "rm.demand": {
        DEMAND_NEW: 'preliminarystaffingdemand',
        DEMAND_INPRG: 'preliminarystaffingdemand',
        DEMAND_CMPLT: 'preliminarystaffingdemand',
    },
    "rm.project": {
        RM_ACTIVE: 'allprojects',
        RM_PEND: 'allprojects',
        RM_CMPLT: 'allprojects',
        RMPJT_ACTIVE: 'activeprojects',
        RMPJTCMPLT: 'completedprojects',
        RM_NEW: 'wavicleprojects',
        RM_WAV_CMPLT: 'wavicleprojects',
        RM_REJ: 'wavicleprojects',
        active: 'activeprojects',
        rejected: 'completedprojects',
        completed: 'completedprojects',
        pending: 'pendingprojects',
        cancelled: 'completedprojects',
        WAV_PROJECT:'wavicleprojects'
    },
    "rm.resourceallocation": {
        RM_NEW: 'new',
        RM_INPRG: 'inprogress',
        RM_REOPEN: 'reopen',
        RM_REV: 'review',
        RM_APVD: 'review',
        RM_CMPLT: 'complete',
        RM_PRTL:'partiallyallocated',
        RM_LOST:'complete'
    },
    "rm/demandpipeline/preliminarystaffingdemand": {
        DEMAND_NEW: 'preliminarystaffingdemand',
        DEMAND_INPRG: 'preliminarystaffingdemand',
        DEMAND_CMPLT: 'preliminarystaffingdemand',
        DEMAND_LOST: 'preliminarystaffingdemand',
    },
    "rm/demandpipeline/projectdemand": {
        "Extend Request":"projectdemand",
        "Replace Request":"projectdemand",
        "Remove Request":"projectdemand",
        "New Add Request":"projectdemand"
    },
    "rm/demandpipeline/inabdemand": {
        "New Add Request": "inabdemand",
        "Replace Request": "inabdemand",
        "Extend Request":  "inabdemand",
        "Remove Request":  "inabdemand",
    },
    "rm/demandpipeline/potentialdemand": {
        Scoped:'potentialdemand',
        Qualified:'potentialdemand',
        Discovery:'potentialdemand',
    },
};

export const getRouteByStatusAndModule = ({ status, module, projectType,pathname }) => {
    const VersionPath = `/${module}${PageConfig["DEALS"].VERSIONCREATION}`
    const isVersionPath = pathname?.includes(VersionPath)
    const versionStatus = {DR_APVD:'approved', DR_INREV:'inreview',DR_PEND:'pending'}
    const StaticRoute = {
        // Scoped Routes
        "scoped-dashboard": {
            SCOPED_NEW: "/scoped-dashboard/scoped-overview/new/:projectid",
            SCOPED_INPRG: "/scoped-dashboard/scoped-review/in-progress/:projectid",
            SCOPED_CMPLT: "/scoped-dashboard/scoped-overview/completed/:projectid",
        },

        // Inab Routes
        "inab": {
            INAB_NEW: "/inab/inab-review-and-approval/new/:inapnum",
            //  INAB_INPROGRESS : "/inab/projects/inab-details/new/:inapnum",
            INAB_REJECTED: "/inab/submit-for-rm/rejected/:inapnum",
            INAB_COMPLETED: "/inab/submit-for-rm/completed/:inapnum",
            INAB_APPROVED: "/inab/submit-for-rm/approved/:inapnum",

            Completed: "/inab/projects/inab-details/completed/:inapnum",
            Cancelled: "/inab/projects/inab-details/rejected/:inapnum",
            Pending: "/inab/projects/inab-details/pending/:inapnum",
            Active: "/inab/projects/inab-details/active/:inapnum",

        },
        // Deal Review Routes
        "deal-review-dashboard": {
            // Two tabs in "new"
            DR_NEW: "/deal-review-dashboard/over-view-project/new/overview/:projectid",
            //  ROUTE_DEALREVIEW_OVERVIEW_PROJECT_INPROGRESS_RESOURCES : "/deal-review-dashboard/over-view-project/inprogress/resources/:projectid",

            // Four tabs in "inprogress"
            DR_INPRG: "/deal-review-dashboard/deal-review/inprogress/:projectid/overview",
            //  ROUTE_DEALREVIEW_INPROGRESS_STAFFING : "/deal-review-dashboard/deal-review/inprogress/staffing/:projectid",
            //  ROUTE_DEALREVIEW_INPROGRESS_STAFFING_INTAKE : "/deal-review-dashboard/deal-review/inprogress/staffingintake/:projectid",
            //  ROUTE_DEALREVIEW_INPROGRESS_REVIEW : "/deal-review-dashboard/deal-review/inprogress/review/:projectid",

            // Two tabs in "reopen"
            DR_REOPEN: "/deal-review-dashboard/over-view-project/reopen/overview/:projectid",
            //  ROUTE_DEALREVIEW_OVERVIEW_PROJECT_REOPEN_RESOURCES : "/deal-review-dashboard/over-view-project/reopen/resources/:projectid",

            // Review and Approval
            DR_INREV: "/deal-review-dashboard/review-and-approval/review/:projectid",
            DR_CUST_REV: "/deal-review-dashboard/review-and-approval/customer-review/:projectid",
            DR_CUST_APVD: "/deal-review-dashboard/review-and-approval/customer-approve/:projectid",
            DR_CUST_REJ: "/deal-review-dashboard/review-and-approval/customer-reject/:projectid",
            DR_APVD: "/deal-review-dashboard/review-and-approval/approved/:projectid",
            DR_CMPLT: "/deal-review-dashboard/deal-review-complete/completed/:projectid",
            DR_DEAL_LOST: "/deal-review-dashboard/deal-review-deallost/deal-lost/:projectid",

            // Legal Questionnaire
            DR_PEND: "/deal-review-dashboard/legal-pending/pending/:projectid",
            DR_VERSION: `/deal-review-dashboard/version-creation/${versionStatus?.[status]}/:projectid/overview`
        },
        //Legal Routes
        "legal-dashboard": {
            // Legal Review - New
            LEG_NEW: "/legal-dashboard/legal-over-view/new/overview/:projectid",
            //  ROUTE_LEGALREVIEW_OVERVIEW_NEW_DEALREVIEW : "/legal-dashboard/legal-over-view/new/dealreview/:projectid",

            // Legal Review - Inprocess
            LEG_INPRCS: "/legal-dashboard/legal-inprocess/inprocess/:projectid",
            //  ROUTE_LEGALREVIEW_SOWGENERATION_INPROGRESS_GENERATESOW : "/legal-dashboard/sow-generation/inprogress/generatesow/:projectid",

            // Legal Review - In Validation
            LEG_VLDT: "/legal-dashboard/sow-upload/in-validation/:projectid",

            //COMPLETED
            LEG_CMPLT: "/legal-dashboard/legal-complete/completed/:projectid",
            // Legal Review - Review
            LEG_REV: "/legal-dashboard/sow-review/review/:projectid",
            LEG_SIG_PEND: "/legal-dashboard/legal-inprocess/pending-sign/:projectid",
            LEG_CUST_REV: "/legal-dashboard/legal-inprocess/customer-review/:projectid",
            LEG_CUST_APVD: "/legal-dashboard/legal-inprocess/approved/:projectid",
            LEG_CUST_REJ: "/legal-dashboard/legal-inprocess/rejected/:projectid",
            LEG_DEAL_LOST: "/legal-dashboard/legal-deallost/deal-lost/:projectid"
        },
        //RM Demand Routes
        "rm/demandpipeline/preliminary-staffing": {
            // RM Demand - New
            DEMAND_NEW: "/rm/demandpipeline/preliminary-staffing/new/overview/:projectid/:demandid",
            //  ROUTE_RM_DEMAND_NEW_PRELIMINARYSTAFFING : "/rm/demandpipeline/new/preliminarystaffing/:projectid",

            // RM Demand - Inprogress
            DEMAND_INPRG: "/rm/demandpipeline/preliminary-staffing/inprogress/overview/:projectid/:demandid",
            //  ROUTE_RM_DEMAND_INPROGRESS_PRELIMINARYSTAFFING : "/rm/demandpipeline/inprogress/preliminarystaffing/:projectid",

            // RM Demand - Completed
            DEMAND_CMPLT: "/rm/demandpipeline/preliminary-staffing/completed/overview/:projectid/:demandid",
            //  ROUTE_RM_DEMAND_COMPLETED_PRELIMINARYSTAFFING : "/rm/demandpipeline/completed/preliminarystaffing/:projectid",
            DEMAND_LOST: "/rm/demandpipeline/preliminary-staffing/demand-lost/overview/:projectid/:demandid",

            // "/rm/project-demand/overview/NewAddRequest/210/WAV50",
            // "/rm/project-demand/preliminarystaffing/NewAddRequest/210/WAV50"
        },
        "rm/demandpipeline/project-demand": {
            //ProjectDemand
            DEMAND_NEW: "/rm/demandpipeline/project-demand/new/overview/:projectid/:demandid",
            DEMAND_APVD: "/rm/demandpipeline/project-demand/approved/overview/:projectid/:demandid",
            DEMAND_REJ: "/rm/demandpipeline/project-demand/rejected/overview/:projectid/:demandid",
            DEMAND_CMPLT: "/rm/demandpipeline/project-demand/completed/overview/:projectid/:demandid",
        },
        "rm/demandpipeline/potential-demand": {
            Scoped: "/rm/demandpipeline/potential-demand/scoped/:projectid",
            Qualified: "/rm/demandpipeline/potential-demand/qualified/:projectid",
            Discovery: "/rm/demandpipeline/potential-demand/discovery/:projectid",
        },
        //RM Project Routes
        "projects": {
            // RM Project - Active Inprogress
            Active: { client: "/projects/project-details/active/overview/:projectid", inab: "/projects/inab-details/active/:inapnum" },
            //  ROUTE_RM_PROJECT_ACTIVE_RESOURCES : "/rm/projects/project-details/active/resources/:projectid",

            // RM Project - Pending
            Pending: { client: "/projects/project-details/pending/overview/:projectid", inab: "/projects/inab-details/pending/:inapnum" },
            //  ROUTE_RM_PROJECT_PENDING_RESOURCES : "/rm/projects/project-details/pending/resources/:projectid",

            // RM Project - Completed
            Completed: { client: "/projects/project-details/completed/overview/:projectid", inab: "/projects/inab-details/completed/:inapnum" },
            //  ROUTE_RM_PROJECT_COMPLETED_RESOURCES : "/rm/projects/project-details/completed/resources/:projectid",
            Rejected: { client: "/projects/project-details/rejected/overview/:projectid", inab: "/projects/inab-details/rejected/:inapnum" },
            // RM Project - Inab Projects
            // { Completed: "/rm/projects/inab-details/completed/:inapnum" },
            // { Active: "/rm/projects/inab-details/active/:inapnum" },
            // { Pending: "/rm/projects/inab-details/pending/:inapnum" },
            Cancelled: { client: "/projects/project-details/cancelled/overview/:projectid", inab: "/projects/inab-details/cancelled/:inapnum" },
            //  ROUTE_RM_PROJECT_INAB_DETAILS_REJECTED : "/rm/projects/inab-details/rejected/:inapnum",

        },
        //RM Resource Allocation Routes
        "rm/resource-allocation-dashboard": {
            // RM Resource Allocation - New
            RM_NEW: { client: "/rm/resource-allocation-dashboard/resource-allocation/new/:projectid/:demandid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/new/:inapnum/:demandid" },

            // RM Resource Allocation - Inprogress
            RM_INPRG: { client: "/rm/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/inprogress/:projectid/:demandid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/inprogress/:inapnum/:demandid" },

            // RM Resource Allocation - Reopen
            RM_REOPEN: { client: "/rm/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/reopen/:projectid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/reopen/:inapnum/:demandid" },

            // RM Resource Allocation - Review
            RM_REV: { client: "/rm/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/review/review/:projectid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/review/review/:inapnum/:demandid" },

            // RM Resource Allocation - Approved
            RM_APVD: { client: "/rm/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/review/approved/:projectid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/review/approved/:inapnum/:demandid" },

            // RM Resource Allocation - Completed
            RM_CMPLT: { client: "/rm/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/review/complete/:projectid/:demandid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/review/complete/:inapnum/:demandid" },

            // RM Resource Allocation - Partial Completed
            RM_PRTL: { client: "/rm/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/partial-allocation/partially-complete/:projectid/:demandid", inab: "/rm/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/partially-complete/:inapnum/:demandid" },

        }
    };

    if(isVersionPath && versionStatus?.[status]){
        status = "DR_VERSION"
    }

    if (!StaticRoute[module]) {
        console.warn(`Invalid module: ${module}`);
        return null;
    }

    const moduleRouteMap = StaticRoute[module];
    // Case-insensitive lookup to handle API returning lowercase (e.g. "active") while
    // some module maps use Pascal-case keys (e.g. "Active" in "projects")
    const statusKey = Object.prototype.hasOwnProperty.call(moduleRouteMap, status)
        ? status
        : Object.keys(moduleRouteMap).find(k => k.toLowerCase() === status?.toLowerCase());

    if (!statusKey || !moduleRouteMap[statusKey]) {
        console.warn(`Invalid status "${status}" for module "${module}"`);
        return null;
    }
    const routeGroup = moduleRouteMap[statusKey];
    console.log(routeGroup)

    if (typeof routeGroup === 'object') return routeGroup[projectType]

    // Generic handling for other modules
    return routeGroup;
};
